import axios from 'axios';
import cfac22 from '../../cfac22';

export async function getUserPartner({ partnerId, uid }) {
  try {
    const result = await axios.get(
      cfac22('API_HOST_V2') + `/userPartner?partnerId=${partnerId}&uid=${uid}`,
      { headers: { 'Full-Url': window.location.href }, withCredentials: true }
    );
    return result.data.response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
